<script setup>
const props = defineProps({
  breadcrumbs: {
    type: Object,
  },
  image: {
    type: Object,
  },
  content: {
    type: Object,
  },
})

const { t } = useI18n()

const show = ref(false)
const showMore = ref(false)
const textContainer = ref(null)

onMounted(async () => {
  await nextTick()
  if (!textContainer.value) {
    return
  }

  const lineHeight = Number.parseFloat(
    getComputedStyle(textContainer.value).lineHeight,
  )
  const numberOfLines = textContainer.value.scrollHeight / lineHeight
  if (numberOfLines > 5) {
    showMore.value = true
  }
})
</script>

<template>
  <div class="type__image">
    <NuxtImg
      v-if="props.image?.src"
      sizes="xs:640px sm:690px md:910px lg:1120px xl:1375px 2xl:1600px"
      densities="1x 2x"
      :src="props.image?.src"
      :alt="props.image?.alt"
      format="webp"
      fetchpriority="high"
      loading="eager"
    />
  </div>
  <div class="row justify-content-center">
    <div class="col-12 col-800-8 type__content">
      <PageBreadcrumbs
        :items="props.breadcrumbs"
        class="type__breadcrumbs"
      />
      <h1
        :id="slugifyString(props.content?.title)"
        class="scale-6 scale-6--bold-uppercase type__name"
      >
        {{ props.content?.title }}
      </h1>
      <div
        ref="textContainer"
        class="scale-2 scale-2--lead type__text intro-text"
        v-html="props.content?.intro"
      />
      <div
        v-show="show"
        class="scale-2 scale-2--lead type__text intro-text"
        v-html="props.content?.text"
      />
      <div class="type__show-more">
        <NuxtLink
          v-if="!show && props.content?.text"
          class="equal-base equal-base--tighter-bold-uppercase link link--grey"
          @click="show = true"
        >
          {{ t('product.category.showMore') }}
        </NuxtLink>
        <NuxtLink
          v-else-if="show"
          class="equal-base equal-base--tighter-bold-uppercase link link--grey"
          @click="show = false"
        >
          {{ t('product.category.showLess') }}
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '~/assets/scss/variables.scss';
@import 'bootstrap/scss/mixins';

.type {
  &__image {
    position: relative;
    display: flex;
    height: 60vh;
    min-height: 400px;
    max-height: clamp(400px, 27.78vw + 311.11px, 800px);
    overflow: hidden;

    @include media-breakpoint-down(640) {
      margin: 0 $padding-container-negative;
    }

    img {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      object-fit: cover;
    }
  }

  &__content {
    margin-top: 25px;
  }

  &__breadcrumbs {
    margin-bottom: 40px;
  }

  &__name {
    margin-bottom: 10px;
  }

  &__show-more {
    margin-top: 20px;
  }
}
</style>
